import React from "react";

const DefinePrereqPopOver = () => {
  return (
    <>
      <h1 className="title">Course prerequisite</h1>
      <p>
        You must study this HSC course in order to be selected for this uni
        course.
      </p>
    </>
  );
};

export default DefinePrereqPopOver;
